import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { ComboboxOption } from "@reach/combobox";
import { SEARCH_SUGGESTION } from "~/constants/testIDs";
import { preventDefaultMouseEvent } from "~/utils/ClickUtils";
export const SearchSuggestionContainer = (param)=>{
    let { value, className, ...props } = param;
    return /*#__PURE__*/ _jsx(ComboboxOption, {
        "data-testid": "".concat(SEARCH_SUGGESTION, "-").concat(value),
        value: value,
        className: tailwindMerge("search-suggestion-container mb-1 flex items-center rounded p-1.5 hover:bg-grey-4", className),
        onMouseDown: preventDefaultMouseEvent,
        ...props
    });
};
